/* Create series
           Parameters:
            1 - line name, should be same as variable name
            2 - line color in rgb format
            3 - is line's area filled
            4 - show bullets on line
            5 - hide line in legend
            6 - show line by default
            7 - line's name, translate
        */

export class ChartLineModel {
    constructor(
        public readonly name: string,
        public readonly color: string,
        public readonly areaFilledOnLine: boolean,
        public readonly showBulletOnLine: boolean,
        public readonly hideLineInLegend: boolean,
        public readonly showLineByDefault: boolean,
        public lineName: string,

        public lineTranslateKey: string,
        public readonly position: number

    ) {

        this.enabled = showLineByDefault;
        this.value = '';
        this.lineNamePopup = '';

    }

    public enabled: boolean;
    public value: string;
    public lineNamePopup: string;
    //public key: string
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/chart-line-model.ts